import { render } from "./CreateCountry.vue?vue&type=template&id=04acca0e&scoped=true"
import script from "./CreateCountry.vue?vue&type=script&lang=js"
export * from "./CreateCountry.vue?vue&type=script&lang=js"

import "./CreateCountry.vue?vue&type=style&index=0&id=04acca0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04acca0e"]])

export default __exports__